<template>
    <div class="text-center home-container">
        <div>
            <img 
                src="/img/logos/orange_black.png" 
                alt="SwiftWork" 
                class="home-logo"
            >
            <div 
                class="link-wrapper" 
                v-if="user && !redirecting"
            >
                <p>Choose a mode</p>
                <router-link 
                    :to="'/office'" 
                    class="btn btn-primary btn-lg" 
                    v-if="user.office_access"
                >
                    <i class="fa fa-desktop" /> Office Mode
                </router-link>
                <router-link 
                    :to="'/engineer'" 
                    class="btn btn-primary btn-lg" 
                    v-if="user.engineer_access"
                >
                    <i class="fa fa-wrench" /> Engineer Mode
                </router-link>
            </div>
            <div v-if="!user">
                Loading
                <i class="fa fa-spinner fa-spin" />
            </div>
            <div v-if="redirecting">
                Redirecting, please wait
                <i class="fa fa-spinner fa-spin" />
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from "../services/AuthService";

export default {
    data: function() {
        return {
            authService: AuthService,
            user: null,
            redirecting: false
        };
    },
    mounted: function() {
        this.authService.refreshUser().then(
            user => {
                this.user = user;
                if (this.user.office_access && !this.user.engineer_access) {
                    this.redirecting = true;
                    setTimeout(() => {
                        this.$router.push({ path: "/office" });
                    }, 1500);
                }
                if (!this.user.office_access && this.user.engineer_access) {
                    this.redirecting = true;
                    setTimeout(() => {
                        this.$router.push({ path: "/engineer" });
                    }, 1500);
                }
            },
            () => {
                this.authService.logout();
                this.$router.push({
                    path: "/login"
                });
            }
        );
    }
};
</script>

<style>
.title {
  display: block;
}

.home-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>






// WEBPACK FOOTER //
// resources/assets/js/components/HomeComponent.vue